export default "__VITE_ASSET__c7f7169e__"